import {defineStore} from 'pinia'
import API from '@/api'

const doumiStore =  defineStore('familyConfig', {
    state: () => ({
        config:{
            allowPrivateMsg: false,
            jobPeriod: 10,
            privateContent: "",
            commentKeywords: ""
        },
        loading: false
    }),
    actions: {

        /**
         *
         * @param deviceId {string}
         * @returns {Promise<ResultDTO<DoumiClientConfig>>}
         */
        async getDoumiClientConfig(deviceId) {
            try {
                this.loading = true;
                const response = await API.doumi.getDoumiClientConfig(deviceId)
                if(response.success && response.data){
                    Object.assign(this.config, response.data)
                }else{
                    console.error('Error fetching users:', response);
                    this.loading = false;
                    return {success: false, data:null, errorMsg: 'error'}
                }

                return response;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching users:', error)
                return {success: false, data:null, errorMsg: 'error'}
            }finally {
                this.loading = false;
            }
        },
        /**
         *
         * @param config {DoumiClientConfig}
         * @returns {Promise<ResultDTO>}
         */
        async doSetFamilyClientConfig(config) {
            try {
                const response = await API.doumi.doSetDoumiClientConfig(config)

                if(response.success){
                    Object.assign(this.config, config)
                }else{
                    console.error('Error register users:', response);
                }

                return response;
            } catch (error) {
                console.error('Error fetching users:', error)
            }
        }
    },
});


export
{
    doumiStore
}
